import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <details>
  <summary>Set up a reverse proxy (recommended)</summary>
      <p>{`We recommend `}<a parentName="p" {...{
          "href": "/docs/advanced/proxy"
        }}>{`setting up a reverse proxy`}</a>{`, so that events are less likely to be intercepted by tracking blockers.`}</p>
      <p>{`We have our `}<a parentName="p" {...{
          "href": "/docs/advanced/proxy/managed-reverse-proxy"
        }}>{`own managed reverse proxy service included in the platform packages`}</a>{`, which routes through our infrastructure and makes setting up your proxy easy.`}</p>
      <p>{`If you don't want to use our managed service then there are several other options for creating a reverse proxy, including using `}<a parentName="p" {...{
          "href": "/docs/advanced/proxy/cloudflare"
        }}>{`Cloudflare`}</a>{`, `}<a parentName="p" {...{
          "href": "/docs/advanced/proxy/cloudfront"
        }}>{`AWS Cloudfront`}</a>{`, and `}<a parentName="p" {...{
          "href": "/docs/advanced/proxy/vercel"
        }}>{`Vercel`}</a>{`.`}</p>
    </details>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      